const APS_URL = "https://preview.insightwin.com/backend/aps";

export default APS_URL;
